import { isAuth } from "actions";
import React from "react";
import { Outlet } from "react-router-dom";

const PrivateRoute = () => {
  if (isAuth()) {
    return <Outlet />;
  } else {
    window.location.href = "https://akun.apjii.or.id/";
    return null;
  }
};

export default PrivateRoute;
